// extracted by mini-css-extract-plugin
export var container = "breadcrumbs-module--container--e369e";
export var genericContainer = "breadcrumbs-module--genericContainer--bf227";
export var icon = "breadcrumbs-module--icon--37b4b";
export var inactive = "breadcrumbs-module--inactive--84619";